import { createSlice } from "@reduxjs/toolkit";
import _find from 'lodash/find';
import _filter from 'lodash/filter';
import {
  getManagerSessions,
  getSession,
  createSession,
  deleteActiveSession,
  deleteSession,
  setLocalSession,
  clearLocalManagerSessions
} from './actions';

export const initialState = {
  manager: { 
    data: [], 
    pagination: { limit: 10, offset: 0, count: 0, total_count: 0 } 
  },
  session: {  
    accessToken: ''
  },
  loading: false
};

const  slice = createSlice({
  name: 'sessions',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getManagerSessions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getManagerSessions.fulfilled, (state, action) => {
        const { sessions, pagination } = action.payload;
        
        state.loading = false;
        state.manager = { data: sessions, pagination };
      })
      .addCase(getManagerSessions.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getSession.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSession.fulfilled, (state, action) => {
        const { session } = action.payload;
        
        state.loading = false;
        state.session = { accessToken: session.access_token };     
      })
      .addCase(getSession.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createSession.pending, (state) => {
        state.loading = true;
      })
      .addCase(createSession.fulfilled, (state, action) => {
        const { session } = action.payload;
        
        state.loading = false;
        state.session = { accessToken: session.access_token };
      })
      .addCase(createSession.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteActiveSession.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteActiveSession.fulfilled, (state, action) => {
        const status = action.payload;
        
        state.loading = false;
        if (status === 204) {
          state.session = initialState.session;
        }     
      })
      .addCase(deleteActiveSession.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteSession.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteSession.fulfilled, (state, action) => {
        const { status, id } = action.payload;
        let data = [];
        let pagination = {};
        const foundedManagerSession = _find(state.manager.data, (item) => item.id === id);
        if (!!foundedManagerSession) {
          data = _filter(state.manager.data, (item) => item.id !== id);
          pagination = { ...state.manager.pagination, count: state.manager.pagination.count - 1, total_count: state.manager.pagination.total_count - 1 };
        }
        
        state.loading = false;
        if (status === 204 && !!foundedManagerSession) {
          state.manager = { data, pagination };
        }
      })
      .addCase(deleteSession.rejected, (state) => {
        state.loading = false;
      })
      .addCase(setLocalSession, (state, action) => {
        const { accessToken } = action.payload;
  
        state.session = { accessToken };
      })
      .addCase(clearLocalManagerSessions, state => {
        state.manager = initialState.manager;
      })
  }
})

export default slice.reducer;